import { TextField } from "@material-ui/core";
import React from "react";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import {
  ManageReservationTable,
  ManageReservationTableBody,
} from "./Tables/ManageReservationTable";

export const ManageReservation = (props) => {
  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Col md={3} xl={3}>
            <TextField
              label="Start Date"
              variant="outlined"
              type="date"
              className="w-100"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Col>
          <Col md={3} xl={2} style={{ alignItems: "center" }}>
            <Button
              variant="link"
              className="enIconBtn mr-3"
              //   onClick={handleShowEdit}
            >
              <i class="fa fa-arrow-right" style={{ color: "black" }}></i>
            </Button>
          </Col>
        </Row>
        <br />
        <div className="seating-dashboard-desktop-table">
          <Table>
            <ManageReservationTable displayGridProps={false} />
          </Table>
        </div>
        <div className="col-12 p-0 seating-dashboard-body-width">
          <Table>
            <ManageReservationTableBody />
          </Table>
        </div>
      </Container>
    </React.Fragment>
  );
};
